import { Image, Space, Typography } from "antd";
import { IconDarkMode } from "../constants/Resources";

const { Text } = Typography;

export const CardItem = ({
  src,
  text,
  strong,
  isUrgent,
  isTextDarkMode,
}: {
  src: string;
  text: string;
  strong?: boolean;
  isUrgent?: boolean;
  isTextDarkMode?: boolean;
}) => {
  return (
    <Space>
      <Image
        preview={false}
        src={src}
        alt=""
        style={{
          filter: isTextDarkMode ? IconDarkMode : "",
        }}
        width={20}
      />
      <Text strong={strong}>{text}</Text>
      {isUrgent && <div className="urgent-package">!!</div>}
    </Space>
  );
};
